<template>
  <v-dialog v-model="isVisible" persistent max-width="600">
    <v-card class="simple-dialog">
      <v-toolbar
          :color="TBColor"
          dark
          class="justify-center"
      >{{ sessionTitle }}
      </v-toolbar>
      <v-card-text class="pt-4">
        <div class="pa-3 pt-4 align-content-center">
          <ul v-if="sessionData" style="list-style: none;">
            <li>Client: <b>{{ (sessionData.client)? sessionData.client : 'unknown'}}</b></li>
            <li>Project: <b>{{ (sessionData.project)? sessionData.project : 'unknown'}}</b></li>
            <li>Started: <b>{{ sessionStarted }}</b></li>
            <li :style="(sessionExpired)?'color:red':((this.timeLeftInSession<3600)?'color:orange':'')">Valid until: <b>{{ expireDateTime }}</b></li>
          </ul>
        </div>
      </v-card-text>
      <v-card-actions class="pr-5 pl-5 pb-4 justify-center">
        <v-btn color="red" dark
               @click.prevent="closeSessionClicked">
          Close session
        </v-btn>
        <v-spacer v-if="!sessionExpired"></v-spacer>
        <v-btn v-if="!sessionExpired" color="green" dark
               @click.prevent="resumeSessionClicked"
          >
          Resume Session
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import workSessionMixin from "@/workSessions/mixins/workSessionMixin";

export default {
  name: "ResumeWorkSessionDialog",
  data: ()=>{
    return {
    }
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    hideWorkSessionDialog(){
      this.$workSessions.displayResumeSessionDialog = false
    },
    resumeSessionClicked() {
      this.hideWorkSessionDialog();
    },
    async closeSessionClicked() {
      //TODO SET FORCE CLOSE FLAG SOMEWHERE ?
      window.console.log('CLOSE SESSION CALLED');
      this.$workSessions.forceCloseWorkSession = true;
      this.hideWorkSessionDialog();
      if(this.currentRouteName !== 'lmra'){
          await this.$router.push({name: 'lmra'});
      }

    }
  },
  computed:{
    TBColor(){
      return (this.sessionExpired)? 'orange' : 'green';
    },
    sessionTitle(){
      return (this.sessionExpired)? this.$vuetify.lang.t('$vuetify.workSessions.resumeSessionDialog.titleActiveSessionExpired') : this.$vuetify.lang.t('$vuetify.workSessions.resumeSessionDialog.titleActiveSession');
    },
    sessionStarted(){
      let date = new Date(this.sessionData.ssdt)
      return date.toLocaleDateString()+" "+date.toLocaleTimeString()
    },
    expireDateTime(){
      if(!this.sessionExpired){
        let date = new Date(this.sessionData.ttl)
        return date.toLocaleDateString()+" "+date.toLocaleTimeString()
      }else{
        return this.$vuetify.lang.t('$vuetify.workSessions.global.expiredLabel')+"!"
      }
    },
    currentRouteName() {
      return this.$route.name;
    }
  },
  mixins : [workSessionMixin]
}
</script>

<style scoped>

</style>